export default "__VITE_ASSET__CibY3czJ__"